export { GOOGLE_MODULE } from './gce.module';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/google/src/index.ts